import React from "react";
import { useTranslation } from "react-i18next";

/**
 * Pill tab bar for the /admin area (Users, Departments, Risk Assessment).
 */
function AdminTabNav({ tabs, activeKey, onSelect }) {
  const { t } = useTranslation();
  return (
    <div className="ml-8 mt-2">
      <div
        className="flex items-center gap-1 overflow-x-auto whitespace-nowrap bg-gray-100/80 rounded-full p-1 shadow-inner ring-1 ring-gray-200 w-full md:w-fit"
        role="tablist"
      >
        {tabs.map((tab) => {
          const active = activeKey === tab.key;
          return (
            <button
              key={tab.key}
              type="button"
              onClick={() => onSelect(tab.key)}
              role="tab"
              aria-selected={active}
              className={
                "shrink-0 flex items-center gap-2 px-3 md:px-4 py-2 text-xs md:text-sm font-medium rounded-full transition " +
                (active ? "bg-white text-gray-900 shadow" : "text-gray-600 hover:text-gray-900")
              }
            >
              {tab.icon}
              <span>{t(tab.labelKey)}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default AdminTabNav;
